var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-center"},[_c('div',{staticClass:"fs-14 red--text"},[_vm._v(" "+_vm._s(_vm.message ? _vm.message : _vm.$t('alertDialog.fillAllForm'))+" ")]),(_vm.isHint)?_c('div',{staticClass:"fs-12 grey--text"},[_vm._v(_vm._s(_vm.$t('alertDialog.needToScrollUp')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }